import React, { useEffect, useRef, useState } from 'react';
import Card from 'components/Layout/Card';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { icons } from 'utils/constants';
import BasicInfo from './BasicInfo';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSubmittedAbstractsDetails, setOpenChatPopup, setPaperData } from 'store/slices';
import { getDataFromLocalStorage, getFilenameFromUrl, getUserType } from 'utils/helpers';
import Loader from 'components/Layout/Loader';
import UpdateAbstractByResourceForm from '../UpdateAbstractByResourceForm';
import RegistrationState from './RegistrationState';
import AbstractState from './AbstractState';
import ReviewState from './ReviewState';
import PlagiarismState from './PlagiarismState';
import AcceptanceState from './AcceptanceState';
import './NewPaperDetails.scss';
import AttendanceState from './AttendanceState';
import Modal from 'components/Layout/Modal';
import ChatTab from './Chat/ChatTab';
import TabLayout from 'components/Layout/TabLayout';
import FullPaper from './FullPaper';
import AddOnServices from './AddOnServices';
import Remarks from './Remarks';
import ResourceInbox from './ResourceInbox';



const NewPaperDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const userType = getUserType();

  const params = useParams();

  const reduxData = useSelector((state) => state.global);
  const { openChatPopup, paperData } = reduxData || {};

  const queryParams = new URLSearchParams(location.search);
  const initialTab = queryParams.get("tab") || "abstract";

  const [childTabType, setChildTabType] = useState(initialTab);

  const isEvent =
    window.location.pathname.includes('event-management') ||
    window.location.pathname.includes('my-events') ||
    window.location.pathname.includes('my-profile');

  const [isLoading, setLoading] = useState(true);
  const [isPaperDetail, setIsPaperDetail] = useState(true);
  // const [paperData, setPaperData] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [btnLoader, setBtnLoader] = useState('');
  const [tabType, setTabType] = useState('0');

  const [data, setData] = useState({
    paper_submitted_status: '',
    plagiarism_comment: '',
    plagiarism_document: '',
    review_comment: '',
    acceptance_status: '',
    registration_acceptance_letter: '',
    acceptance_date: '',
    paper_submitted_date: '',
    plagiarism_date: '',
    review_date: '',
    registration_date: '',
    plagiarism_document_file_name: '',
    acceptance_letter_file_name: '',
    republish_date: '',
    is_republish_by_admin: '0',
    is_remodify: '2',
    reviewing_file: '',
    reviewing_file_file_name: '',
  });

  const { resource_role } = getDataFromLocalStorage();

  const tabs = [
    { key: 'abstract', label: 'Abstract' },
    { key: 'full_paper', label: 'Full Paper' },
    { key: 'add_on_services', label: 'Add-On Services' },
    { key: 'remarks', label: 'Remarks' },
    ...(userType === "resource" ? [{ key: 'email', label: 'Email' }] : []),
  ];

  const getPaperDetails = async () => {
    const response = await dispatch(
      fetchSubmittedAbstractsDetails(params.paperId)
    );
    const resData = response?.data || null;
    const statusData = resData?.submittedPapersStatus || {};
    dispatch(setPaperData(resData));
    setData({
      ...data,
      ...statusData,
      plagiarism_document_file_name: getFilenameFromUrl(
        statusData?.plagiarism_document
      ),
      acceptance_letter_file_name: getFilenameFromUrl(
        statusData?.registration_acceptance_letter
      ),
    });
    setLoading(false);
    setBtnLoader('');
  };

  useEffect(() => {
    getPaperDetails();
    // return () => {
    //   dispatch(setPaperData({}));
    // };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { paper_submitted_status, plagiarism_status: plagiarismStatus } =
    data || {};

  const status = +paper_submitted_status || 1;
  const plagiarismAccepted = +plagiarismStatus === 1;

  const handleLeadChange = (newLead) => {
    dispatch(setPaperData({ ...paperData, lead: newLead }));
  };


  return (
    <div className="new-paper-details-container">
      {isEdit && (
        <UpdateAbstractByResourceForm
          onHide={() => {
            setIsEdit(false);
          }}
          elem={isEdit}
          handleSuccess={() => {
            getPaperDetails();
          }}
        />
      )}
      {!isLoading && (
        <Card className="cmb-18">
          <div className="bg-f4ff color-new-car text-14-500-17 cps-44 cpt-12 cpe-28 cpb-12 d-flex align-items-center gap-2">
            <div
              className="d-flex"
              onClick={() => {
                navigate(-1);
              }}
            >
              <img
                src={icons.leftArrow}
                alt="back"
                className="h-21 me-3 pointer"
              />
            </div>
            <div
              className="d-flex align-items-center justify-content-between pointer flex-grow-1"
              onClick={() => {
                setIsPaperDetail(!isPaperDetail);
              }}
            >
              <div>{paperData?.paperId}</div>
              <i
                className={`${isPaperDetail ? 'bi bi-chevron-up' : 'bi bi-chevron-down'
                  }`}
                style={{ fontSize: '15px' }}
              />
            </div>
          </div>

          {isPaperDetail && (
            <BasicInfo
              paperData={paperData}
              triggerChatTab={() => {
                dispatch(setOpenChatPopup(true));
              }}
              triggerEmailTab={() => {
                setChildTabType('email');
              }}
              onLeadChange={handleLeadChange}
            />
          )}
        </Card>
      )}

      {!isLoading && (
        <Card className="cps-20 cpe-20  cpt-8 cpb-8 cmb-20">
          <TabLayout
            tabs={tabs}
            activeKey={childTabType}
            onChange={setChildTabType}
            variant="background"
          />
        </Card>
      )}

      {isLoading ? (
        <Card className="cps-44 cpt-25 cpe-44 cpb-25">
          <div className="pt-5 pb-5">
            <Loader size="md" />
          </div>
        </Card>
      ) : childTabType === 'abstract' ? (
        <Card className="cps-44 cpt-25 cpe-44 cpb-25 paper-tracking-section">
          {/* {resource_role !== '3' ? ( */}
          <>
            {/* Abstract */}
            <AbstractState
              data={data}
              paperData={paperData}
              isEvent={isEvent}
              handleSuccess={() => {
                getPaperDetails();
              }}
              setIsEdit={setIsEdit}
              onLeadChange={handleLeadChange}

            />
            {/* Plagiarism */}
            <PlagiarismState
              btnLoader={btnLoader}
              setBtnLoader={setBtnLoader}
              data={data}
              paperData={paperData}
              handleSuccess={() => {
                getPaperDetails();
              }}
            />
            {/* Review */}
            <ReviewState
              status={status}
              plagiarismAccepted={plagiarismAccepted}
              data={data}
              paperData={paperData}
              handleSuccess={() => {
                getPaperDetails();
              }}
            />
            {/* Acceptance */}
            <AcceptanceState
              status={status}
              paperData={paperData}
              data={data}
              handleSuccess={() => {
                getPaperDetails();
              }}
              setTabType={setTabType}
              tabType={tabType}
            />

            {/* Registration */}
            <RegistrationState
              status={status}
              paperData={paperData}
              data={data}
              handleSuccess={() => {
                getPaperDetails();
              }}
              setTabType={setTabType}
              tabType={tabType}
            />

            {/* Attendance */}
            <AttendanceState
              status={status}
              paperData={paperData}
              data={data}
              handleSuccess={() => {
                getPaperDetails();
              }}
            />
          </>
          {/* ) : (
            <div className='color-red text-center'>Oops! You’re not authorized to view this page.</div>
          )} */}
        </Card>
      ) : childTabType === 'full_paper' ? (
        <FullPaper />
      ) : childTabType === "add_on_services" ?
        <AddOnServices paperData={paperData} />
        : childTabType === "remarks" ?
          <Remarks
            paperData={paperData}
            onLeadChange={handleLeadChange}
            onSuccess={(updatedPaper) => dispatch(setPaperData(updatedPaper))}
          /> : childTabType === "email" ? <ResourceInbox paperData={paperData} /> : <></>}

      {openChatPopup && (
        <>
          <Modal
            size="lg"
            onHide={() => {
              dispatch(setOpenChatPopup(false));
            }}
            titleBesideClose="Chat"
            titleBesideCloseClassName="text-18-300"
            isTitleBorder
            isTitleVerticalCenter
          >
            <div className="cp-20">
              <ChatTab paperData={paperData} />
            </div>
          </Modal>
        </>
      )}
    </div>
  );
};

export default NewPaperDetails;
